import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { IntroductionSandboxToolPage } from 'src/app/model/page/group/api-docs/introduction-sandbox-tool-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-introduction-sandbox-tool-page',
  templateUrl: './introduction-sandbox-tool-page.component.html',
  styleUrls: ['./introduction-sandbox-tool-page.component.scss']
})
export class IntroductionSandboxToolPageComponent implements OnInit {
  introductionSandboxToolPage: IntroductionSandboxToolPage = {} as IntroductionSandboxToolPage;
  pageName = 'Sandbox Tool - Introduction';

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'sandbox-tool-introduction') {
        this.introductionSandboxToolPage.htmlTitle = title.htmlTitle;
      }
    });
    const query = { 'fields.title': this.pageName };
    this.contentfulService.getPageContentResponse(query).then((resIncludes) => {
      this.mapBanner(resIncludes.includes.Entry);
      this.sharedDataService.addSharedData(this.introductionSandboxToolPage.banner);
      this.mapPageInfo(resIncludes.items);
      this.mapVideo(resIncludes.includes.Asset);
    });
  }

  private mapBanner(introductionSandboxToolPageEntries: Entry<any>[]) {
    introductionSandboxToolPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.introductionSandboxToolPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }

  private mapVideo(assets: Entry<any>[]) {
    // console.log('video', assets);

    const asset = assets.forEach((asset) => {
      if (asset.fields['title'] === this.pageName) {
        
        let filePath:any=asset.fields['file'];
        this.introductionSandboxToolPage.video = filePath.url;
      }
    });
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.introductionSandboxToolPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.introductionSandboxToolPage.banner.url = entry.fields?.url;
      this.introductionSandboxToolPage.banner.editorEmail = editorDetails?.pop();
      this.introductionSandboxToolPage.banner.editorShortName = editorDetails?.pop();
      this.introductionSandboxToolPage.banner.editorFullName = editorDetails?.pop();
      this.introductionSandboxToolPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
}
